import React from 'react'

const Simplebutton = ({color}) => {
  return (
    <div>
         <button className={`border text-xs font-semibold bg-white hover:bg-rose-50 border-rose-400 transition-colors duration-100  text-rose-500 px-3 py-1 rounded-sm`}>INSTALL</button>
    </div>
  )
}

export default Simplebutton